/* Shopify AJAX cart drawer in the visual language of the Vercel storefront. */
(function () {
  'use strict';

  var drawer = document.getElementById('MonttcoCartDrawer');
  var backdrop = document.getElementById('MonttcoCartBackdrop');
  var body = drawer && drawer.querySelector('[data-cart-body]');
  var footer = drawer && drawer.querySelector('[data-cart-footer]');
  var subtotal = drawer && drawer.querySelector('[data-cart-subtotal]');
  var lastFocus = null;
  if (!drawer || !backdrop || !body) return;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }
  function money(cents, currency) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency || 'BRL' }).format((cents || 0) / 100);
  }
  function updateCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (element) { element.textContent = '(' + count + ')'; });
  }
  function render(cart) {
    updateCounts(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div class="bag-empty"><p>Sua sacola está vazia.</p><a class="btn btn-solid" href="/collections/all">Ver todas as peças</a></div>';
      footer.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item, index) {
      var image = item.image ? '<a class="bag-item-media" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '&width=220" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="bag-item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      return '<article class="bag-item">' + image + '<div class="bag-item-info"><a class="bag-item-name" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant + '<p class="bag-item-price mono">' + money(item.final_line_price, cart.currency) + '</p><div class="bag-item-controls"><label class="sr-only" for="CartQty-' + index + '">Quantidade</label><input class="bag-item-qty" id="CartQty-' + index + '" type="number" min="0" value="' + item.quantity + '" data-cart-line="' + (index + 1) + '"><button type="button" class="bag-item-remove" data-cart-remove="' + (index + 1) + '">Remover</button></div></div></article>';
    }).join('');
    subtotal.textContent = money(cart.total_price, cart.currency);
    footer.hidden = false;
  }
  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); }).then(render);
  }
  function change(line, quantity) {
    body.setAttribute('aria-busy', 'true');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (response) { return response.json(); }).then(render).finally(function () { body.removeAttribute('aria-busy'); });
  }
  function open(opener) {
    lastFocus = opener || document.activeElement;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    load().then(function () { var close = drawer.querySelector('[data-cart-close]'); if (close) close.focus(); });
  }
  function close() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.querySelectorAll('#cart-icon-bubble, #searchMobileBagBtn').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) { event.preventDefault(); open(trigger); });
  });
  drawer.querySelector('[data-cart-close]').addEventListener('click', close);
  backdrop.addEventListener('click', close);
  drawer.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-line]');
    if (input) change(parseInt(input.getAttribute('data-cart-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });
  drawer.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (remove) change(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  document.addEventListener('monttco:cart-changed', function (event) { load().then(function () { if (!event.detail || event.detail.open !== false) open(); }); });

  // Keep the header count right on load and when returning via back/forward cache.
  function syncCount() { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { updateCounts(c.item_count); }).catch(function () {}); }
  syncCount();
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncCount(); });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.dataset.monttcoNativeSubmit === 'true') return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (response) { if (!response.ok) throw new Error('add'); return response.json(); })
      .then(function () { return load(); })
      .then(function () { open(form); })
      .catch(function () { form.dataset.monttcoNativeSubmit = 'true'; form.submit(); })
      .finally(function () { if (button) button.disabled = false; });
  });
})();
